import { Component, Input, EventEmitter, Output, AfterViewInit } from "@angular/core";
import { Partner } from "@edp-models/edp-partner.model";
import { TranslateService } from "@ngx-translate/core";
import { Contract } from "@edp-components/edp-contract";
import { environment } from "@edp-environments/environment";
import { Store, select } from "@ngrx/store";
import { IAppState } from "@edp-store/state/app.state";
import { getContract } from "@edp-store/selectors/contract.selectors";
import { CloseSidebarAction } from "@edp-store/actions/layout.actions";

@Component({
    selector: "edp-partnerships",
    templateUrl: "./edp-partnerships.component.html",
    styleUrls: ["./edp-partnerships.component.scss"]
})
export class EdpPartnershipsComponent implements AfterViewInit {
    @Output() public closeSideBar = new EventEmitter<boolean>();
    @Output() public stopLoading = new EventEmitter<boolean>();
    @Input() set allPartnerships(partnerships: Partner[]) {
        this.partnerships = partnerships;
    }

    public path: string[];
    public partnerships: Partner[];
    public hasPack: boolean;

    constructor(private translate: TranslateService, private store: Store<IAppState>) {
        this.store.pipe(select(getContract)).subscribe((contract: Contract) => {
            this.hasPack = contract.HasPack ? true : false;
            this.path = [`/energia/${contract.ContractId}/leisure`];
        });
    }

    ngAfterViewInit(): void {
        this.stopLoading.emit();
    }

    public close(): void {
        if (environment.isMobile) {
            this.closeSideBar.emit();
            this.store.dispatch(new CloseSidebarAction());
        }
    }
}
